<template>
  <div
    class="w-full max-w-screen-xl mx-auto bg-white lg:rounded-lg overflow-hidden pt-12.5 lg:pt-0"
  >
    <div class="w-full flex flex-col lg:flex-row">
      <div class="w-full lg:w-1/2">
        <div class="is-fixed-ar is-1x1">
          <div class="ar-inside bg-grey-lightest">
            <img :src="image" :alt="altText" class="full-bg-cover" />
          </div>
        </div>
      </div>
      <div class="w-full lg:w-1/2 pt-5 pl-3.75 pr-6 pb-10 lg:p-15">
        <p
          class="font-primary font-extrabold text-blue-brand text-28 lg:text-32 -tracking-1/2 leading-1 mb-2.5"
        >
          {{ name }}
        </p>
        <p class="font-primary font-extrabold text-14 leading-1">{{ role }}</p>
        <p class="font-primary font-extrabold text-14 leading-1 mb-5">{{ location }}</p>
        <div v-html="content" class="text-16 leading-1.63"></div>
      </div>
    </div>
    <div v-if="reviews.length > 0" class="w-full px-5 py-10 lg:pb-20 bg-grey-lightest">
      <div class="hidden lg:block m-auto max-w-content-xs">
        <h2
          class="font-primary font-extrabold text-blue-brand text-26 -tracking-1/2 leading-1 mb-5"
        >
          Testimonials
        </h2>
        <div
          v-for="(review, index) in reviews"
          :key="index"
          class="my-5 shadow-bottom last:shadow-none"
        >
          <review-component :review="review"></review-component>
        </div>
      </div>
      <div class="block lg:hidden w-full relative">
        <div
          class="absolute z-10 top-0 left-0 h-full w-5 bg-gradient-to-r from-grey-lightest"
        ></div>
        <div
          class="absolute z-10 top-0 right-0 h-full w-5 bg-gradient-to-l from-grey-lightest"
        ></div>
        <div ref="carousel" class="w-full overflow-hidden">
          <div
            v-for="(review, index) in reviews"
            :key="index"
            ref="carouselCell"
            class="carousel__cell w-full max-w-280 md:max-w-sm mr-5"
          >
            <review-component :review="review"></review-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Route from '../src/Route';
import get from 'lodash/get';
import Flickity from 'flickity';
import ReviewComponent from './ReviewComponent.vue';

export default {
  components: { ReviewComponent },

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      teamMember: null,
    };
  },

  computed: {
    name() {
      return get(this.teamMember, 'name');
    },

    role() {
      return get(this.teamMember, 'role');
    },

    location() {
      return get(this.teamMember, 'location');
    },

    content() {
      return get(this.teamMember, 'content');
    },

    reviews() {
      return get(this.teamMember, 'reviews', []);
    },

    image() {
      return get(this.teamMember, 'image.url');
    },

    altText() {
      return get(this.teamMember, 'image.alt_text');
    },
  },

  created() {
    this.getTeamMember();
  },

  methods: {
    getTeamMember() {
      this.loading = true;
      this.error = null;

      axios
        .get(Route('json.team-members.show', { team_member: this.id }))
        .then((response) => {
          if (response.status === 200) {
            this.teamMember = response.data.team_member;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem loading team members.';
        })
        .then(() => {
          this.loading = false;
        })
        .then(() => {
          this.initiateCarousel();
        });
    },

    initiateCarousel() {
      let cells = this.$refs.carouselCell;

      if (!cells) {
        return;
      }

      let carousel_cell_count = cells.length;

      const carousel = new Flickity(this.$refs.carousel, {
        wrapAround: carousel_cell_count > 1,
        pageDots: true,
        setGallerySize: true,
        prevNextButtons: false,
      });
    },
  },
};
</script>
